import Card from './components/card'
import Logo from './components/logo'
import Header from './components/header'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'
import Fields from './components/fields'
import GoogleIcons from './components/google-icons'
import GoogleAppLink from '/components/editor/google/fronts/components/app-link'

const GoogleGiftFront = ({ show, backgroundColour, googleDarkBackgroundColour, fgColour }) => {
  return (
    <>
      <Card backgroundColour={backgroundColour} googleDarkBackgroundColour={googleDarkBackgroundColour} fgColour={fgColour}>
        <GoogleIcons show={show}/>
      <Logo />
      <div className="inset giftCard">
        <Header />
      </div>
      <Barcode />
      <div className="inset giftCard">
        <Fields/>
        <GoogleAppLink />
      </div>
      </Card>
      <HeroImage/>
    </>
  )
}

export default GoogleGiftFront